module.exports = __webpack_public_path__ + "static/trust-infographic.0148ead2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trust-infographic.png
// module id = 485
// module chunks = 59963396046441